exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "od-photo-tooltip .thumbnail,[od-photo-tooltip] .thumbnail{max-height:40px;max-width:60px}od-photo-tooltip od-tooltip-hover img,[od-photo-tooltip] od-tooltip-hover img{display:block;max-width:224px;max-height:224px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader/lib/loader.js!./javascripts/common/directives/od-photo-tooltip.less
 ** module id = 798
 ** module chunks = 0 1 3 4 5 6
 **/